import React, { useState } from 'react';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  return (
    <header className="header">
      <div className="logo">
        <img src="/secLogo.png" alt="Logo" className="logo-img" />
      </div>

      <div className={`nav ${menuOpen ? 'active' : ''}`}>

        <ul>
          <li><a href="/"><button className="btn">Home</button></a></li>
          <li><a href="/features"><button className="btn">Features</button></a></li>
           <li><a href="/ContactUs"><button className="btn">Contact Us</button></a></li> 
        </ul>
        <div className="auth-buttons mobile-auth">
          <a href="/login"><button className="btn btn-outline-light">Log in</button></a>
          <a href="/register"><button className="btn btn-outline-light">Register</button></a>
        </div>
      </div>

      <div className="auth-buttons desktop-auth">
        <a href="/login"><button className="btn btn-outline-light">Log in</button></a>
        <a href="/register"><button className="btn btn-outline-light">Register</button></a>
      </div>

      <div className="nav-toggle" onClick={toggleMenu}>
        <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
        <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
        <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
      </div>

    </header>
  );
}

export default Header;
